module.exports = __webpack_public_path__ + "img/img.943756b0.png";